// Simulate an expired JWT token
export const createExpiredToken = () => {
  const now = Math.floor(Date.now() / 1000);
  const payload = {
    sub: "test-user",
    exp: now - 3600, // set the expiration time to 1 hour ago
    iat: now - 7200,
  };

  // simple base64 encoding, simulate JWT structure
  const header = btoa(JSON.stringify({ alg: "HS256", typ: "JWT" }));
  const encodedPayload = btoa(JSON.stringify(payload));
  const signature = btoa("fake-signature");

  return `${header}.${encodedPayload}.${signature}`;
};
